import { render, staticRenderFns } from "./DatosGeneralClientes.vue?vue&type=template&id=2d8d7590&"
import script from "./DatosGeneralClientes.vue?vue&type=script&lang=js&"
export * from "./DatosGeneralClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports